import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { clienteApi } from '../services/api';
import { PageHeader, Loading, EmptyState } from '../components/ui';
import { formatarTelefone, formatarData, iniciais } from '../lib/format';
import { Search, Phone, FileText, Users } from 'lucide-react';

export function ClientesPage() {
  const [busca, setBusca] = useState('');
  const [page, setPage] = useState(1);

  const { data, isLoading } = useQuery({
    queryKey: ['clientes', busca, page],
    queryFn: () => clienteApi.listar({ busca, page, limit: 20 }).then(r => r.data),
  });

  const vazio = !isLoading && (data?.data?.length || 0) === 0;

  return (
    <div className="space-y-6">
      <PageHeader
        titulo="Clientes"
        descricao={`${data?.total ?? 0} cliente${(data?.total ?? 0) === 1 ? '' : 's'} na base`}
      />

      <div className="relative">
        <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-ink-400 pointer-events-none" />
        <input
          type="text"
          placeholder="Buscar por nome ou telefone..."
          value={busca}
          onChange={e => { setBusca(e.target.value); setPage(1); }}
          className="input-field !pl-10"
        />
      </div>

      <div className="table-shell">
        {isLoading ? (
          <Loading />
        ) : vazio ? (
          <EmptyState
            icon={Users}
            titulo="Nenhum cliente encontrado"
            descricao="Clientes são cadastrados automaticamente ao criar um pedido."
          />
        ) : (
          <div className="divide-y divide-ink-100">
            {data?.data?.map((cliente: any) => (
              <div key={cliente.id} className="px-6 py-4 hover:bg-brand-50/40 transition-colors">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-brand-100 to-brand-200 text-brand-700 flex items-center justify-center text-[13px] font-bold shrink-0">
                    {iniciais(cliente.nome)}
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-semibold text-ink-900 truncate">{cliente.nome}</p>
                    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-1">
                      <span className="flex items-center gap-1.5 text-[13px] text-ink-500">
                        <Phone className="w-3.5 h-3.5" />
                        {formatarTelefone(cliente.telefone)}
                      </span>
                      {cliente.observacoes && (
                        <span className="flex items-center gap-1.5 text-[13px] text-ink-400 truncate">
                          <FileText className="w-3.5 h-3.5 shrink-0" />
                          {cliente.observacoes}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="hidden sm:block text-right shrink-0">
                    <p className="text-2xs font-semibold uppercase tracking-wider text-ink-400">Cliente desde</p>
                    <p className="text-[13px] font-medium text-ink-600 mt-0.5">{formatarData(cliente.criadoEm)}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
